/**
 * The locales the product is available in. One entry per locale: the language whose translation
 * file the interface loads, the name and flag shown for choosing it, and how a model is told to write in it.
 */
export const LOCALES = {
  "en-gb": { language: "en", label: "English", flag: "🇬🇧", promptName: "British English" },
  "fr-fr": { language: "fr", label: "Français", flag: "🇫🇷", promptName: "French (France)" },
} as const;

/** A locale we are available in, as a long lower-case tag: the key an explanation is stored under. */
export type Locale = keyof typeof LOCALES;

/** The locale used when none is known. */
export const DEFAULT_LOCALE: Locale = "en-gb";

/** Every available locale. */
export const LOCALE_KEYS = Object.keys(LOCALES) as [Locale, ...Locale[]];

/** The available locale for a raw tag such as a browser's `fr-CA`: the first whose language the tag
 *  starts with, otherwise the default locale. */
export function resolveLocale(raw: string | null | undefined): Locale {
  const language = raw?.trim().toLowerCase().split(/[-_]/)[0];
  return LOCALE_KEYS.find((locale) => LOCALES[locale].language === language) ?? DEFAULT_LOCALE;
}
